import { IReviewPeriod } from "@/models/reviewPeriod/reviewPeriod.types"
import {
  ReviewPeriodParser,
  IReviewPeriodRaw,
} from "@/models/reviewPeriod/reviewPeriod.parser"
import { QueryResult } from "@/api/utils/types"
import { useQuery } from "@/api/utils/useQuery"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"

export interface IReviewPeriodService {
  getForAccount(billingAccountId: number | null): QueryResult<IReviewPeriod[]>
}

class ReviewPeriodServiceClass implements IReviewPeriodService {
  getForAccount(billingAccountId: number | null): QueryResult<IReviewPeriod[]> {
    return useQuery({
      ...BackofficeRestQueries.reviewPeriods.list(billingAccountId ?? 0),
      enabled: !!billingAccountId,
      placeholderData: [],
      useRawResponse: true,
      parserFn: (rawData: IReviewPeriodRaw[]) =>
        (rawData ?? []).map((item) => ReviewPeriodParser.toDomain(item)),
    })
  }
}

export const ReviewPeriodService = new ReviewPeriodServiceClass()
